const REACT_APP_BFF_URL = process.env.REACT_APP_BFF_URL

/**
 * Obtiene el estado del procesamiento automático
 */
export const getAutoStatus = async () => {
  try {
    const response = await fetch(`${REACT_APP_BFF_URL}/quotes/auto/status`)
    const data = await response.json()
    return data
  } catch (error) {
    console.error("Error fetching auto status:", error)
    throw error
  }
}

/**
 * Alterna el procesamiento automático entre ON/OFF
 */
export const toggleAutoProcessing = async (token) => {
  try {
    const response = await fetch(`${REACT_APP_BFF_URL}/quotes/auto/toggle`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.error("Error toggling auto processing:", error)
    throw error
  }
}

/**
 * Actualiza la configuración del procesamiento automático
 */
export const updateAutoConfig = async (token, intervalSeconds, limitPerRun) => {
  try {
    const response = await fetch(
      `${REACT_APP_BFF_URL}/quotes/auto/config?interval_seconds=${intervalSeconds}&limit_per_run=${limitPerRun}`,
      {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.error("Error updating auto config:", error)
    throw error
  }
}

/**
 * Procesa correos manualmente (para testing)
 */
export const processQuotesManual = async (limit = 1) => {
  try {
    const response = await fetch(`${REACT_APP_BFF_URL}/quotes/test-process?limit=${limit}`, {
      method: "POST",
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.error("Error processing quotes:", error)
    throw error
  }
}

/**
 * Obtiene presupuestos procesados
 */
export const getProcessedQuotes = async (token, limit = 50, sellerEmail = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() })
    if (sellerEmail) {
      params.append("seller_email", sellerEmail)
    }

    const response = await fetch(`${REACT_APP_BFF_URL}/quotes/processed?${params}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    })
    const data = await response.json()
    if (data?.success && Array.isArray(data.data)) {
      return data.data
    }
    // Fallback in case backend returns plain array
    if (Array.isArray(data)) {
      return data
    }
    return []
  } catch (error) {
    console.error("Error fetching processed quotes:", error)
    throw error
  }
}

export const getProcessedQuoteById = async (token, quoteId) => {
  const response = await fetch(`${REACT_APP_BFF_URL}/quotes/processed/${quoteId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  const data = await response.json()
  if (data?.success && data.data) {
    return data.data
  }
  if (response.status === 404) {
    throw new Error("Presupuesto no encontrado")
  }
  throw new Error(data?.detail || "Error al obtener el presupuesto")
}

